"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Handouts;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const cancelable_promise_1 = require("cancelable-promise");
const react_i18next_1 = require("react-i18next");
const UserContext_1 = require("../contexts/UserContext");
const ThemeContext_1 = require("../ThemeContext");
const Loading_1 = __importDefault(require("../components/Loading"));
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
const Risk_1 = __importDefault(require("../api/Risk"));
const react_native_webview_1 = require("react-native-webview");
function Handouts(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const { size, tenPercentOfScreen } = (0, ResponsiveContext_1.useResponsiveContext)();
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const promise = react_1.default.useRef(null);
    const [loading, setLoading] = react_1.default.useState(true);
    const [url, setUrl] = react_1.default.useState(null);
    const refresh = () => {
        promise.current?.cancel();
        setLoading(true);
        promise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then(token => Risk_1.default.getLaborLawPosterUrlByEmployee(token, props.route.params?.id || null))).then(data => {
            if (data.url)
                setUrl(data.url);
        }).catch((e) => {
            console.error(e);
        }).finally(() => {
            setLoading(false);
        });
    };
    react_1.default.useEffect(() => {
        refresh();
        return () => promise.current?.cancel();
    }, []);
    return ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, backgroundColor: THEME.AlwaysWhite }, children: loading
            &&
                (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }, children: (0, jsx_runtime_1.jsx)(Loading_1.default, { retryable: false, loading: loading }) })
            ||
                url && (react_native_1.Platform.OS === 'web' ? ((0, jsx_runtime_1.jsx)("iframe", { src: url, title: t('common:appmenus.laborLawPosters'), style: { flex: 1, width: '100%', height: '100%', border: 'none' } })) : ((0, jsx_runtime_1.jsx)(react_native_webview_1.WebView, { source: { uri: url }, style: { flex: 1, width: '100%', height: '100%' } }))) }));
}
